<div class="filter-bar">
      <div class="action-buttons">
        <button mat-flat-button >Print viste liste til excel fil</button>

        <button mat-flat-button >
          Print viste liste m. QR koder til mdb fil
        </button>

        <button mat-flat-button >
          Vælg QR skilte filer
        </button>

        <button mat-flat-button >
          Print Pdf med Qr koder
        </button>

        <input #qrFilesInput
               type="file"
               multiple
               hidden />

       
      </div>

</div>


  <app-base-list-page #baseListPage
                      [headersList]="headerList"
                      [multiSelectFilterLists]="multiSelectFilterLists"
                      [checkboxes]="checkboxes"
                      (rowClick)="equipmentClicked($event)">
  </app-base-list-page>
